import type { IconSvgObject } from './types';

const GalleryHorizontalIcon: IconSvgObject = [
  ["path", { d: "M2 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 3L11 3C8.64298 3 7.46447 3 6.73223 3.73223C6 4.46447 6 5.64298 6 8L6 16C6 18.357 6 19.5355 6.73223 20.2678C7.46447 21 8.64298 21 11 21H13C15.357 21 16.5355 21 17.2678 20.2678C18 19.5355 18 18.357 18 16V8C18 5.64298 18 4.46447 17.2678 3.73223C16.5355 3 15.357 3 13 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryHorizontalIcon;
